import { render, staticRenderFns } from "./ratingManagement.vue?vue&type=template&id=250f0ec2&scoped=true"
import script from "./ratingManagement.vue?vue&type=script&lang=js"
export * from "./ratingManagement.vue?vue&type=script&lang=js"
import style0 from "./ratingManagement.vue?vue&type=style&index=0&id=250f0ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f0ec2",
  null
  
)

export default component.exports